import { render } from "./RecruitmentSkeleton.component.vue?vue&type=template&id=1db76ade"
import script from "./RecruitmentSkeleton.component.vue?vue&type=script&lang=js"
export * from "./RecruitmentSkeleton.component.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton,QIcon});
